<template>
  <div
    v-if="showMaterial"
    class="player-material"
  >
    <img
      v-if="materialIconUrl"
      :src="materialIconUrl"
      alt="图标"
      @click="clickMaterial('icon')"
    >
    <span
      v-if="materialText"
      class="txt-wrapper"
      @click="clickMaterial('txt')"
    >
      <span>{{ materialText }}</span>
      <i class="arrow" />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import emoutils from 'emoutils';
import { fixHttps } from '@/utils/no-import-meta/url';
import { EFeedReserveType } from '@/constants/feed';
import { ModelMetaFeed } from '@/types/model';


const enum EEmitEvent {
  showPlayerMaterial = 'show-player-material',
  onClickMaterial = 'on-click-material',
}

export default defineComponent({
  props: {
    feed: {
      type: Object as PropType<ModelMetaFeed>,
      default() {
        return {};
      },
    },
  },
  emits: [EEmitEvent.showPlayerMaterial, EEmitEvent.onClickMaterial],
  computed: {
    exposureMaterialInfo() {
      return this.feed?.reserve?.[EFeedReserveType.exposureMaterialInfo];
    },
    isCommercialVideo() {
      return !!this.feed.reserve[EFeedReserveType.businessCard];
    },
    iconSchema() {
      if (this.isCommercialVideo) {
        return this.exposureMaterialInfo.schemeMultiStyle;
      }
      return this.exposureMaterialInfo.schemeDynamicStyleIcon;
    },
    textSchema() {
      if (this.isCommercialVideo) {
        return this.exposureMaterialInfo.schemeMultiStyle;
      }
      return this.exposureMaterialInfo.schemeDynamicStyleText;
    },
    materialIconUrl() {
      // 没有schema不展示
      if (!this.iconSchema) return '';
      // 多标签场景下，没有文案不展示
      if (this.isCommercialVideo && !this.exposureMaterialInfo.textDynamicStyle) {
        return '';
      }
      return fixHttps(this.exposureMaterialInfo.iconDynamicStyle);
    },
    materialText() {
      // 没有schema不展示
      if (!this.textSchema) return '';
      const txt = this.exposureMaterialInfo.textDynamicStyle || '';
      const LENGTH = 6;
      const MINCHARCODE = 19968;  // 首位汉字的码点
      const isMultibyteStr =  txt.split('').every(c => (c.codePointAt(0) || 0) > MINCHARCODE); // 如果文本都是由汉字或者多字节字符组成
      if (isMultibyteStr && txt.length > LENGTH) {
        return `${emoutils.substr(txt, 0, LENGTH)}...`;
      }
      return txt;
    },
    showMaterial() {
      const { exposureMaterialName: name, materialId: id } = this.exposureMaterialInfo;
      const isShowMaterial = !!(name || id);
      this.$emit(EEmitEvent.showPlayerMaterial, isShowMaterial);
      return isShowMaterial;
    },
  },
  methods: {
    clickMaterial(type: string) {
      const schema = type === 'icon' ? this.iconSchema : this.textSchema;
      this.$emit(EEmitEvent.onClickMaterial, schema);
    },
  },
});
</script>

<style lang="scss" scoped>
.player-material {
  display: flex;
  align-items: center;
  @include responsiveStyleSingle(margin-right, 2.6667, 'vw');
  img {
    @include responsiveStyleSingle(height, 6.4, 'vw');
    width: auto;
  }
  .txt-wrapper {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    white-space: nowrap;
    @include responsiveStyleSingle(height, 6.4, 'vw');
    @include responsiveStyleSingle(padding-left, 2.4,'vw');
    @include responsiveStyleSingle(padding-right, 1.6,'vw');
    background: rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(250, 212, 56, 0.3);
    @include responsiveStyleSingle(border-radius,3.7333, 'vw');
    span {
      @include responsiveStyleSingle(font-size, 3.7333, 'vw');
      font-weight: bold;
      color: #fadf38;
      white-space: nowrap;
    }
    .arrow {
      @include responsiveStyleSingle(height, 3.2, 'vw');
      @include responsiveStyleSingle(width, 3.2, 'vw');
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IA\
      rs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJKADAAQAAAABAAAAJ\
      AAAAAAqDuP8AAABI0lEQVRYCe3X3QnCMBAH8ERxC6EvTlFdQIfwQcRRHELEB3cQFxCn8MGKW9ga87c0oFC4S3JFMAHxKPn49dIcrV\
      KppQykDPxZBjT1fo0xuiomU/TvZ6ej1tpQx3L69aidgXma6oDfo8i3AFLHcvqRQR+TGrOQQpFB2Cal9c7BhFCstGObkBllMQ5mkYP\
      svIz1TLFAQEij2CBplBdIEuUNkkIFgSRQwaDYKHIdwsJtDUceR/+7TpW3fN02pu16FBAmr1HDlQ0ubjGj5i4mBtFAdX26b2yhGrm1\
      tdq7mBj83DMUDIpduYNAsTHYVW+QBMYbJIXxAkli2CBpDAvUBYYFKq/jGV7wMejdIr8pNtP6VWohDFDkY48t6+K7rMlU+k8Z8M3AC\
      3iX9801GVAiAAAAAElFTkSuQmCC');
      background-size: 100% 100%;
    }
  }
}
</style>
